// Trusted Value Icons JS
document.addEventListener('DOMContentLoaded', function () {
  var swiperWrapper = document.querySelector('.trust-value-icons .swiper-wrapper');
  var bannerInterval = swiperWrapper.getAttribute('data-interval');
  var bannerSpeed = swiperWrapper.getAttribute('data-transition');

  var swiper = new Swiper('.trust-value-icons .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true, // Enables infinite scrolling
    autoplay: {
      delay: bannerInterval,
      disableOnInteraction: false,
    },
    speed: bannerSpeed,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
      }
    }
  });
});
